import "./index.scss";
import "web-ui/styles/fonts.scss";

import "./init";

import React from "react";
import ReactDOM from "react-dom";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import communityArtsStyles from "./CommunityArts/CommunityArts.module.scss";
import MathLandingPage from "./MathLandingPage";
import WordpressPage from "./WordpressPage";

const pathToWordpressIdMap = {
  communityartsprogram: 6,
  mathLandingPage: 42,
};

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route
          element={
            <WordpressPage
              className={communityArtsStyles.page}
              id={pathToWordpressIdMap["communityartsprogram"]}
            />
          }
          path="/communityartsprogram"
        />
        <Route
          element={
            <MathLandingPage id={pathToWordpressIdMap["mathLandingPage"]} />
          }
          path="/math"
        />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById("root"),
);
